export default __webpack_public_path__ + "static/flyerBack2-2ec1df21e319efe556c6c9fa751f48b7.jpg";